export const COLOR_MODE_STORAGE_KEY = 'deviareColorMode';

export const LIGHT_TOKENS = {
  bodyColor: '#f5f5f5',
  contentColor: '#ffffff',
  sidebarColor: '#FAFCFF',
  headerColor: '#ffffff',
  darkThemeText: '#4D5766',
  labelcolor: '#4D5766',
  successMessageBGColor: '#ffffff',
  dmBorder: '#e7ebf0',
  dmMuted: '#647184',
  dmTextStrong: '#263548',
  dmInput: '#ffffff',
  dmRow: '#ffffff',
  dmRowAlt: '#f8fafc',
  dmPage: '#f5f5f5',
  dmHover: 'rgba(0, 0, 0, 0.04)',
};

export const DARK_TOKENS = {
  bodyColor: '#0b1220',
  contentColor: '#121a2b',
  sidebarColor: '#0e1728',
  headerColor: '#0e1728',
  darkThemeText: '#e7eef8',
  labelcolor: '#d5deea',
  successMessageBGColor: '#182234',
  dmBorder: '#2a3850',
  dmMuted: '#9aabc0',
  dmTextStrong: '#f4f7fb',
  dmInput: '#182234',
  dmRow: '#121a2b',
  dmRowAlt: '#172033',
  dmPage: '#0b1220',
  dmHover: 'rgba(255, 255, 255, 0.08)',
};

const TOKEN_TO_VAR = {
  bodyColor: '--bodyColor',
  contentColor: '--contentColor',
  sidebarColor: '--sidebarColor',
  headerColor: '--headerColor',
  darkThemeText: '--darkThemeText',
  labelcolor: '--labelcolor',
  successMessageBGColor: '--successMessageBGColor',
  dmBorder: '--dm-border',
  dmMuted: '--dm-muted',
  dmTextStrong: '--dm-text-strong',
  dmInput: '--dm-input',
  dmRow: '--dm-row',
  dmRowAlt: '--dm-row-alt',
  dmPage: '--dm-page',
  dmHover: '--dm-hover',
};

const CUSTOMER_SURFACE_VARS = [
  '--bodyColor',
  '--contentColor',
  '--sidebarColor',
  '--headerColor',
  '--darkThemeText',
  '--labelcolor',
  '--successMessageBGColor',
];

let lightSurfaces = null;

export const getColorMode = () => {
  try {
    return localStorage.getItem(COLOR_MODE_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch (error) {
    return 'light';
  }
};

export const rememberLightSurfaces = () => {
  if (typeof document === 'undefined') {
    return;
  }
  const root = document.documentElement;
  const snapshot = {};
  CUSTOMER_SURFACE_VARS.forEach((name) => {
    const value = root.style.getPropertyValue(name).trim();
    if (value) {
      snapshot[name] = value;
    }
  });
  lightSurfaces = snapshot;
};

export const applyColorMode = (mode) => {
  if (typeof document === 'undefined') {
    return 'light';
  }
  const next = mode === 'dark' ? 'dark' : 'light';
  const root = document.documentElement;
  const tokens = next === 'dark' ? DARK_TOKENS : LIGHT_TOKENS;
  root.setAttribute('data-color-mode', next);
  root.style.colorScheme = next;
  try {
    localStorage.setItem(COLOR_MODE_STORAGE_KEY, next);
  } catch (error) {
    // Ignore storage errors (private browsing).
  }
  Object.entries(TOKEN_TO_VAR).forEach(([key, cssVar]) => {
    const savedSurface = next === 'light' && lightSurfaces && lightSurfaces[cssVar];
    root.style.setProperty(cssVar, savedSurface || tokens[key]);
  });
  return next;
};

export const getChartPalette = (mode) => {
  if (mode === 'dark') {
    return {
      text: DARK_TOKENS.dmTextStrong,
      axis: '#c5d2e4',
      grid: DARK_TOKENS.dmBorder,
      tooltipBg: DARK_TOKENS.dmInput,
      tooltipBorder: DARK_TOKENS.dmBorder,
    };
  }
  return {
    text: LIGHT_TOKENS.darkThemeText,
    axis: '#6c6c6c',
    grid: LIGHT_TOKENS.dmBorder,
    tooltipBg: '#ffffff',
    tooltipBorder: LIGHT_TOKENS.dmBorder,
  };
};
